const styles = (theme) => ({
  root: {},
  filterContainer: {
    margin: `0 auto ${theme.spacing.unit}px`,
    maxWidth: 350,

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing.unit * 2,
    },

    // Remove top margin from filters
    '& label': {
      marginTop: 0,
    },
  },
  requestHolder: {
    marginBottom: theme.spacing.unit * 2.5,
  },
});

export default styles;
